const isRussian = text => {
  return /[а-яё]/i.test(text);
};

export default isRussian;
